"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOME_COUNTRY_BUTTON = exports.FOREIGN_COUNTRY_BUTTON = exports.DIALOG = void 0;
const HOME_COUNTRY_BUTTON = exports.HOME_COUNTRY_BUTTON = 'home-country-button';
const FOREIGN_COUNTRY_BUTTON = exports.FOREIGN_COUNTRY_BUTTON = 'foreign-country-button';
const DIALOG = exports.DIALOG = 'dialog';